import {
  keepPreviousData,
  queryOptions,
  useQuery
} from '@tanstack/react-query';

import type { GetRubricBannersQueryVariables } from '@schema/cart';

import API from '@api';
import { withSsrCache } from '../../ssrCache';

/** Баннеры меняются редко — кэшируем на 10 минут */
const BANNERS_STALE_TIME = 10 * 60 * 1000;
const BANNERS_GC_TIME = 15 * 60 * 1000;

export const rubricBannersQueryOptions = (
  params: GetRubricBannersQueryVariables = {}
) =>
  queryOptions({
    queryKey: ['rubricBanners', params],
    queryFn: () => API.getRubricBanners(params),
    // Без известной рубрики запрос не имеет смысла
    enabled: !!params.type,
    staleTime: BANNERS_STALE_TIME,
    gcTime: BANNERS_GC_TIME
  });

export const useRubricBannersQuery = (
  params: GetRubricBannersQueryVariables = {}
) => useQuery(rubricBannersQueryOptions(params));

type IndexCoreBannersParamsT = Parameters<typeof API.getIndexCoreBanners>[0];

/**
 * Баннеры главной бэк отдаёт для магазина корзины (берёт его по cartToken),
 * в баннерах цены товаров. В ключе xStore.storeChangeCount, а не xStoreId:
 * на холодном старте xStoreId приходит позже (null -> N) и дал бы второй
 * запрос за загрузку; счётчик растёт только при реальной смене магазина
 */
export const indexCoreBannersQueryOptions = (
  params: IndexCoreBannersParamsT = {},
  storeChangeCount = 0
) =>
  withSsrCache(
    queryOptions({
      queryKey: ['indexCoreBanners', params, storeChangeCount],
      queryFn: () => API.getIndexCoreBanners(params),
      staleTime: BANNERS_STALE_TIME,
      gcTime: BANNERS_GC_TIME,
      // при смене региона держим старые баннеры до прихода новых, без скелетона
      placeholderData: keepPreviousData
    }),
    'product'
  );

export const useIndexCoreBannersQuery = (
  params: IndexCoreBannersParamsT = {},
  storeChangeCount = 0
) => useQuery(indexCoreBannersQueryOptions(params, storeChangeCount));
